import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection, doc, getDoc } from 'firebase/firestore'

export default class Organizations extends BaseModel {
  constructor() {
    super(collection(db, 'organizations'))
  }

  static async get(id: string) {
    try {
      const docSnap = await getDoc(doc(db, 'organizations', id));
      if (docSnap.exists()) {
        return docSnap.data();
      } else {
        console.error("No such document!");
        return null;
      }
    } catch (error) {
      console.error("Error getting document:", error);
      return null;
    }
  }
}
